import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProgressBar from './ProgressBar';
import LoadingSpinner from './LoadingSpinner';

import CommError from '../../Shared/Errors/Errors'

import './ViewSurvey.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const ViewSurvey = (
    {
        errSurvey,
        errSurveyClear,
        errSurveyDetailClear,

        header1,
        header2,
        header3,

        curSurvey,

        sortBy,
        sortOrder,
        sortColumn,
  
        isOpen,
        surveyExportDetails,
        surveyDetail,
        surveyExport,
        onAfterOpen,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestCancel={onRequestCancel} style={styling}>
        <CommError error={errSurvey.error} onClose={errSurveyClear} />
        <CommError error={errSurvey.errorDetail} onClose={errSurveyDetailClear} />

        <div className="viewsurvey editpages productManagement">
            <h1 className="header">{header1}</h1>
            <p className="header">{header2}{header3}
                <button onClick={surveyExport} className="btn btn-primary survey pull-right">Export</button>
            </p>
            <span className="back" onClick={onRequestCancel}><i className="fa fa-arrow-circle-left"></i>Back</span>

            <div className="row">
                <span id="startExport">
                    {
                        surveyExportDetails.complete_export === false ?
                            <LoadingSpinner />
                        :
                            null
                    }
                </span>
                <span id="progress_bar"><strong> Export Progress: {surveyExportDetails.percent_complete}%</strong>
                    <ProgressBar percentage={surveyExportDetails.percent_complete} />
                </span>

                <div className="col-md-12">
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th id="surveyNumber" onClick={sortColumn}>Survey Number<i className="fa fa-sort fa-xs"></i></th>
                                <th id="proposalNumber" onClick={sortColumn}>Proposal<i className="fa fa-sort fa-xs"></i></th>
                                <th id="salesPersonName" onClick={sortColumn}>Sales Person<i className="fa fa-sort fa-xs"></i></th>
                                <th id="score" onClick={sortColumn}>Score<i className="fa fa-sort fa-xs"></i></th>
                                <th id="comments" onClick={sortColumn}>Comments<i className="fa fa-sort fa-xs"></i></th>
                                <th id="customerName" onClick={sortColumn}>Customer<i className="fa fa-sort fa-xs"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                curSurvey.length ?
                                   curSurvey.sort((a,b) => {
                                        switch (sortBy) {
                                            case 'surveyNumber': {
                                                if (parseInt(a.surveyNumber) > parseInt(b.surveyNumber))
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (parseInt(a.surveyNumber) < parseInt(b.surveyNumber))
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }

                                            case 'proposalNumber': {
                                                if (a.proposalNumber > b.proposalNumber)
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (a.proposalNumber < b.proposalNumber)
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }

                                            case 'salesPersonName': {
                                                if (a.salesPersonName > b.salesPersonName)
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (a.salesPersonName < b.salesPersonName)
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }

                                            case 'score': {
                                                if (a.score > b.score)
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (a.score < b.score)
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }

                                            case 'comments': {
                                                if (a.comments > b.comments)
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (a.comments < b.comments)
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }

                                            case 'customerName': {
                                                if (a.customerName > b.customerName)
                                                    return sortOrder === 'Ascending' ? 1 : -1
                                                else if (a.customerName < b.customerName)
                                                    return sortOrder === 'Ascending' ? -1 : 1
                                                else
                                                    return 0
                                            }
                                        } 
                                   })
                                   .map((survey, index) => {
                                        return <tr key={index}>
                                            <td className="survey_number" survey={survey.surveyNumber} onClick={surveyDetail}>{survey.surveyNumber}</td>
                                            <td>{survey.proposalNumber}</td>
                                            <td>{survey.salesPersonName}</td>
                                            <td>{survey.score}</td>
                                            <td>{survey.comments}</td>
                                            <td>{survey.customerName}</td>
                                        </tr>
                                }) : null
                            }
                        </tbody>
                    </table>
                 </div>

                <div className="form-group buttons pull-right">
                    <button onClick={surveyExport} className="btn btn-primary survey">Export</button>
                </div>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default ViewSurvey